import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "truncate py-0.5 font-normal" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs font-normal py-0.5"
}

import { format } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import {
  CriticalPathContext,
  CriticalPathDelta,
  CriticalPathNodeEx,
} from "shared/types/CriticalPath";
import { calculateDeltaForPlannedAndActualEvent } from "shared/views/critical_path/criticalPathDelta";
import {
  useDeltaTextClass,
  useDeltaTextWithBackgroundClass,
  useFormattedDelta,
} from "../composables";
import "./criticalPath.css";

const dateFormat = "dd.MM.yyyy";


export default /*#__PURE__*/_defineComponent({
  __name: 'CriticalPathGraphNodeHoverItem',
  props: {
    criticalPathNode: {},
    context: {},
    deltaForNode: {},
    sourceId: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const plannedEvent = computed(() => props.context.plannedEventsBySourceId[props.sourceId] ?? null);

const actualEvent = computed(() => props.context.actualEventsBySourceId[props.sourceId] ?? null);

const formattedPlannedEvent = computed(() =>
  plannedEvent.value ? `${format(plannedEvent.value.end, dateFormat)}` : null,
);

const formattedActualEvent = computed(() => {
  if (!actualEvent.value) {
    return t("analytics.critical_path.not_started");
  }
  return `${
    actualEvent.value.end
      ? format(actualEvent.value.end, dateFormat)
      : t("analytics.critical_path.active")
  }`;
});

const deltaForPlannedAndActualEvent = computed(() =>
  calculateDeltaForPlannedAndActualEvent(
    plannedEvent.value,
    actualEvent.value,
    props.context.projectDurationSettings,
  ),
);

const formattedDeltaForPlannedAndActualEvent = useFormattedDelta(deltaForPlannedAndActualEvent);

const isPlannedEventUsedForNodeDifference = computed(
  () =>
    props.deltaForNode.plannedEvent &&
    props.deltaForNode.plannedEvent._id ===
      props.context.plannedEventsBySourceId[props.sourceId]?._id,
);

const isActualEventUsedForNodeDifference = computed(
  () =>
    props.deltaForNode.actualEvent &&
    props.deltaForNode.actualEvent._id ===
      props.context.actualEventsBySourceId[props.sourceId]?._id,
);

const isDifferenceUsedForNodeDifference = computed(
  () =>
    deltaForPlannedAndActualEvent.value !== null &&
    deltaForPlannedAndActualEvent.value === props.deltaForNode.workingDays &&
    (!props.deltaForNode.actualEvent ||
      props.deltaForNode.actualEvent.source_id === props.sourceId),
);

const isEntireRowHighlighted = computed(
  () =>
    isPlannedEventUsedForNodeDifference.value &&
    (isActualEventUsedForNodeDifference.value || isDifferenceUsedForNodeDifference.value),
);

const isInDelayMessageVisible = computed(
  () =>
    !actualEvent.value?.end &&
    deltaForPlannedAndActualEvent.value !== null &&
    deltaForPlannedAndActualEvent.value !== 0,
);

const differenceClass = useDeltaTextClass(deltaForPlannedAndActualEvent);
const differenceBackgroundClass = useDeltaTextWithBackgroundClass(deltaForPlannedAndActualEvent);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["oaiCriticalPathGraphNodeHoverItem", isEntireRowHighlighted.value ? 'bg-gray-100 font-semibold' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.context.tagsByTypeAndSourceId[`component_${_ctx.sourceId}`]?.name || "unknown"), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["py-0.5", 
        isPlannedEventUsedForNodeDifference.value &&
        !isActualEventUsedForNodeDifference.value &&
        !isEntireRowHighlighted.value
          ? 'bg-gray-200 w-min px-0.5 rounded font-semibold'
          : ''
      ])
    }, _toDisplayString(formattedPlannedEvent.value), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["py-0.5", 
        isActualEventUsedForNodeDifference.value &&
        !isPlannedEventUsedForNodeDifference.value &&
        !isEntireRowHighlighted.value
          ? 'bg-gray-200 w-min px-0.5 rounded font-semibold'
          : ''
      ])
    }, _toDisplayString(formattedActualEvent.value), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(differenceClass))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["py-0.5", 
          isEntireRowHighlighted.value
            ? ['w-min rounded-full px-2 whitespace-nowrap', _unref(differenceBackgroundClass)]
            : ''
        ])
      }, _toDisplayString(_unref(formattedDeltaForPlannedAndActualEvent)), 3),
      (isInDelayMessageVisible.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "  (" + _toDisplayString(_unref(t)("analytics.critical_path.in_delay")) + ")", 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})